import { render, staticRenderFns } from "./ShipmentList.vue?vue&type=template&id=42c6c08e&scoped=true"
import script from "./ShipmentList.vue?vue&type=script&lang=js"
export * from "./ShipmentList.vue?vue&type=script&lang=js"
import style0 from "./ShipmentList.vue?vue&type=style&index=0&id=42c6c08e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c6c08e",
  null
  
)

export default component.exports